import { render, staticRenderFns } from "./InvestmentUpload.vue?vue&type=template&id=47380bfb"
import script from "./InvestmentUpload.vue?vue&type=script&lang=js"
export * from "./InvestmentUpload.vue?vue&type=script&lang=js"
import style0 from "./InvestmentUpload.vue?vue&type=style&index=0&id=47380bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports